import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'itemType';

const itemTypeService = {
  getData: () => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/data`,
    });
  },

  getItem: (id) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },

  createItem: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  updateItem: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },
};

export default itemTypeService;
